import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Institute_UGscholarshipsEle from '../Scholarships/Institute_UGscholarshipsEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Scholarship " />
            <Institute_UGscholarshipsEle />
        </>
    )
}

export default Main